var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 10.9375H23.4375V25H21.875V10.9375ZM6.25 16.4062L7.8125 14.8438V25H6.25V16.4062ZM3.125 19.5312L4.6875 17.9688V25H3.125V19.5312ZM9.375 13.2812L10.9375 11.7188V25H9.375V13.2812ZM12.5 11.7188L14.0625 13.2812V24.9878H12.5V11.7188ZM16.4062 15.625L17.1875 14.8438V25H15.625V14.8438L16.4062 15.625ZM18.75 13.2812L20.3125 11.7188V25H18.75V13.2812ZM0 22.6562L1.5625 21.0938V25H0V22.6562ZM25 3.125V9.375H23.4375V5.79834L16.4062 12.8174L11.7188 8.12988L0 19.8608V17.6392L11.7188 5.93262L16.4062 10.6201L22.3267 4.6875H18.75V3.125H25Z",
    fill: "#045BA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeboard);
export default __webpack_public_path__ + "static/media/tradeboard.dc8db8be3606b6c011ef6a2cf3419b12.svg";
export { ForwardRef as ReactComponent };